import React from 'react'
import { ParallaxLayer } from '@react-spring/parallax'
import { PredeterminedMyProjects } from './predeterminedConstants';
import './style.scss'
import { Carousel } from 'react-bootstrap';
import { useState } from 'react';
import { IoIosArrowDropleftCircle, IoIosArrowDroprightCircle } from 'react-icons/io';

function HomeMyProjects() {
  const [page, setPage] = useState(0);

  const handleSelect = (selectedPage, e) => {
    setPage(selectedPage);
  };

  function renderProject(project) {
    return (
      <Carousel.Item style={{height: '60vh', display: 'block'}}>
        <a href={project.hyperlink} target='_blank' rel="noreferrer">
          <div className='my-projects-page-placeholder'>
            <div className='my-projects-page' style={{backgroundImage:`url(${project.imageUrl})`}} />
          </div>
          <Carousel.Caption>
            <h5>{project.name}</h5>
            <p>{project.message}</p>
          </Carousel.Caption>
        </a>
      </Carousel.Item>
    )
  }

  function renderCarousel() {
    return (
      <Carousel 
        activeIndex={page} 
        onSelect={handleSelect} 
        className={'my-projects-carousel'} 
        fade
        nextIcon={<IoIosArrowDroprightCircle style={{width:'50px', height:'50px'}}/>}
        prevIcon={<IoIosArrowDropleftCircle style={{width:'50px', height:'50px'}}/>}
        nextLabel='' 
        prevLabel=''
      >
        { PredeterminedMyProjects.map((project) => renderProject(project)) }
      </Carousel>
    )
  }


  return (
    <ParallaxLayer offset={5} className={'my-projects-container'}>
      <div className={'my-projects-title'}>My <b>Projects</b></div>
      { renderCarousel() }
    </ParallaxLayer>
  )
}

export default HomeMyProjects
